import { observer } from 'mobx-react';

import styles from './EntryTypePopup.module.scss';

import { Tabs } from 'chaika-enums';

import { translate } from '@chaika/i18n/helper';
import { Select } from '@components/Select';
import { CreateParams } from '@hooks/useCreateEntry/types';
import { useCreateEntryModal } from '@hooks/useCreateEntry/useCreateEntryModal';
import { Button, ButtonTheme } from '@components/Button';
import { EhrPageAttributes } from 'chaika-test-attributes';
import { CreateEntryOptions } from '@hooks/useCreateEntry/useCreateEntry';

interface Props {
    staticEntryTypeId?: string;
    recordId: number;
    otherParamsForCreation: CreateParams;
    redirectTab?: Tabs;
    onCreate: (params: CreateParams, options: CreateEntryOptions) => Promise<void>;
}

export const EntryTypePopup = observer(
    ({ recordId, onCreate, staticEntryTypeId, redirectTab, otherParamsForCreation }: Props) => {
        const {
            isDataValid,
            selectedEntryTypeId,
            entryTypeOptions,
            selectedUserId,
            userOptions,
            showUserSelect,
            onEntryTypeSelect,
            onUserSelect,
            onConfirm,
            onCancel,
        } = useCreateEntryModal({ recordId, staticEntryTypeId, onCreate, otherParamsForCreation, redirectTab });

        return (
            <div className={styles.root}>
                <div className={styles.container}>
                    <div className={styles.title}>{translate('selectEntryTypeAndAuthor')}</div>
                    <Select
                        forcePlaceholder
                        disabled={!!staticEntryTypeId}
                        title={translate('type')}
                        selectedValue={selectedEntryTypeId}
                        options={entryTypeOptions}
                        onChange={onEntryTypeSelect}
                        placeholder={translate('findAndSelectFromList')}
                    />
                    {showUserSelect && (
                        <Select
                            forcePlaceholder
                            title={translate('author')}
                            selectedValue={selectedUserId}
                            options={userOptions}
                            onChange={onUserSelect}
                            placeholder={translate('findAndSelectFromList')}
                        />
                    )}
                </div>
                <div className={styles.buttons}>
                    <Button
                        disabled={!isDataValid}
                        dataTest={EhrPageAttributes.ConfirmRepresentativeButton}
                        onClick={onConfirm}
                        theme={ButtonTheme.Main}
                    >
                        {translate('createEntry')}
                    </Button>
                    <Button
                        dataTest={EhrPageAttributes.RepresentativePopupCancel}
                        onClick={onCancel}
                        theme={ButtonTheme.Secondary}
                    >
                        {translate('cancel')}
                    </Button>
                </div>
            </div>
        );
    },
);
